const documentStatus = {
  EM_SECRETARIA: 'EM_SECRETARIA',
  AGUARDANDO_AUDIENCIA: 'AGUARDANDO_AUDIENCIA',
  AGUARDANDO_DECISAO_JUDICIAL: 'AGUARDANDO_DECISAO_JUDICIAL',
  AGUARDANDO_DECURSO_DE_PRAZO: 'AGUARDANDO_DECURSO_DE_PRAZO',
  CONCLUSO_AO_MEMBRO: 'CONCLUSO_AO_MEMBRO',
  AGUARDANDO_INQUERITO: 'AGUARDANDO_INQUERITO',
  AGUARDANDO_EXPEDIENTE_RECIBADO: 'AGUARDANDO_EXPEDIENTE_RECIBADO',
  AGUARDANDO_PRECATORIA: 'AGUARDANDO_PRECATORIA',
  TRANSITADO_EM_JULGADO: 'TRANSITADO_EM_JULGADO',
  AGUARDANDO_DECURSO_DE_PRAZO_PARA_INTERPOSICAO_DE_RECURSO:
    'AGUARDANDO_DECURSO_DE_PRAZO_PARA_INTERPOSICAO_DE_RECURSO',
  AGUARDANDO_LAUDO: 'AGUARDANDO_LAUDO',
  AGUARDANDO_RETORNO_DE_AUTOS: 'AGUARDANDO_RETORNO_DE_AUTOS',
  AGUARDANDO_CUMPRIMENTO_DE_RECOMENDACAO: 'AGUARDANDO_CUMPRIMENTO_DE_RECOMENDACAO',
  AGUARDANDO_PRAZO_DE_CUMPRIMENTO_DO_COMPROMISSO_DE_AJUSTAMENTO:
    'AGUARDANDO_PRAZO_DE_CUMPRIMENTO_DO_COMPROMISSO_DE_AJUSTAMENTO',
  AGUARDANDO_DECURSO_DE_PRAZO_RECURSAL_DE_INDEFERIMENTO_DE_NOTICIA_DE_FATO:
    'AGUARDANDO_DECURSO_DE_PRAZO_RECURSAL_DE_INDEFERIMENTO_DE_NOTICIA_DE_FATO',
  AGUARDANDO_DECISAO_ORGAO_SUPERIOR: 'AGUARDANDO_DECISAO_ORGAO_SUPERIOR',
  ARQUIVADO: 'ARQUIVADO',
  AGUARDANDO_RESPOSTA_DE_REQUISITORIO_MINISTERIAL:
    'AGUARDANDO_RESPOSTA_DE_REQUISITORIO_MINISTERIAL',
  AGUARDANDO_CUMPRIMENTO_DE_ACORDO: 'AGUARDANDO_CUMPRIMENTO_DE_ACORDO',
  DECLINADO_PARA_MESMO_RAMO: 'DECLINADO_PARA_MESMO_RAMO',
  DECLINADO_PARA_OUTRO_RAMO: 'DECLINADO_PARA_OUTRO_RAMO',
  DENUNCIADO: 'DENUNCIADO',
  AGUARDANDO_HOMOLOGACAO_DE_ACORDO: 'AGUARDANDO_HOMOLOGACAO_DE_ACORDO',
  CAUTELAR_ENCAMINHADA_PARA_O_JUDICIARIO: 'CAUTELAR_ENCAMINHADA_PARA_O_JUDICIARIO',
  MINUTADO: 'MINUTADO',
};

export const ACT_TYPES = {
  ADMINISTRATIVE: 'Ato Administrativo',
  COMMON: 'Ato Comum',
  FINALISTIC: 'Ato Finalístico',
};

const documentStatusList = subtype => {
  let arrayStatus = [];
  for (const key in documentStatus) {
    if (documentStatus.hasOwnProperty.call(documentStatus, key)) {
      arrayStatus.push({
        name: documentStatus[key].replace(/_/g, ' '),
        value: documentStatus[key],
      });
    }
  }
  if (listInfanciaEJuventude.some(e => e.code === subtype.code && e.name === subtype.name)) {
    arrayStatus.push(
      {
        name: 'REPRESENTADO',
        value: 'REPRESENTADO',
      },
      {
        name: 'REMIDO',
        value: 'REMIDO',
      },
    );
  }
  return arrayStatus;
};

const listSubtypeGeneric = [
  {
    code: '920015',
    name: 'Denúncia',
    act: ACT_TYPES.FINALISTIC,
    targetDocumentStatus: documentStatus.AGUARDANDO_DECISAO_JUDICIAL,
  },
  {
    code: '920013',
    name: 'Petição Inicial',
    act: ACT_TYPES.FINALISTIC,
    targetDocumentStatus: null,
  },
];

const listInfanciaEJuventude = [
  {
    code: '920478',
    name: 'Remissão - Cumulada com medida protetiva',
    act: ACT_TYPES.FINALISTIC,
    targetDocumentStatus: null,
  },
  {
    code: '920078',
    name: 'Remissão - Advertência',
    act: ACT_TYPES.FINALISTIC,
    targetDocumentStatus: null,
  },
  {
    code: '920081',
    name: 'Remissão - Liberdade Assistida',
    act: ACT_TYPES.FINALISTIC,
    targetDocumentStatus: null,
  },
  {
    code: '920080',
    name: 'Remissão - Prestação de Serviço à Comunidade',
    act: ACT_TYPES.FINALISTIC,
    targetDocumentStatus: null,
  },
  {
    code: '920079',
    name: 'Remissão - Reparação de Dano',
    act: ACT_TYPES.FINALISTIC,
    targetDocumentStatus: null,
  },
  {
    code: '920076',
    name: 'Remissão - Simples',
    act: ACT_TYPES.FINALISTIC,
    targetDocumentStatus: null,
  },
  {
    code: '920017',
    name: 'Representação por Ato Infracional',
    act: ACT_TYPES.FINALISTIC,
    targetDocumentStatus: null,
  },
  {
    code: '920036',
    name: 'Aditamento de Representação por Ato Infracional',
    act: ACT_TYPES.FINALISTIC,
    targetDocumentStatus: null,
  },
  {
    code: '920253',
    name: 'Despacho',
    act: ACT_TYPES.FINALISTIC,
    targetDocumentStatus: null,
  },
  {
    code: '920198',
    name: 'Arquivamento com remessa ao Judiciário',
    act: ACT_TYPES.FINALISTIC,
    targetDocumentStatus: null,
  },
  {
    code: '920198',
    name: 'Manifestação ao Judiciário',
    act: ACT_TYPES.FINALISTIC,
    targetDocumentStatus: documentStatus.AGUARDANDO_RETORNO_DE_AUTOS,
  },
];

const listDespacho = [
  {
    code: '920198',
    name: 'Manifestação ao Judiciário',
    act: ACT_TYPES.FINALISTIC,
    targetDocumentStatus: documentStatus.AGUARDANDO_RETORNO_DE_AUTOS,
  },
  {
    code: '920198',
    name: 'Manifestação ao Judiciário (Caso NF)',
    act: ACT_TYPES.FINALISTIC,
    targetDocumentStatus: null,
  },
  {
    code: '920198',
    name: 'Manifestação ao Judiciário (Homologação)',
    act: ACT_TYPES.FINALISTIC,
    targetDocumentStatus: documentStatus.AGUARDANDO_DECISAO_JUDICIAL,
  },
  {
    code: '920253',
    name: 'Despacho',
    act: ACT_TYPES.FINALISTIC,
    targetDocumentStatus: documentStatus.AGUARDANDO_RETORNO_DE_AUTOS,
  },
  {
    code: '920054',
    name: 'Dilação de prazo (com prazo)',
    act: ACT_TYPES.FINALISTIC,
    targetDocumentStatus: documentStatus.AGUARDANDO_RESPOSTA_DE_REQUISITORIO_MINISTERIAL,
  },
  {
    code: '920261',
    name: 'Ofício comunicação (sem prazo)',
    act: ACT_TYPES.COMMON,
    targetDocumentStatus: null,
  },
  {
    code: '920261',
    name: 'Ofício requisição (com prazo)',
    act: ACT_TYPES.COMMON,
    targetDocumentStatus: null,
  },
  {
    code: '920258',
    name: 'Req. Diligência',
    act: ACT_TYPES.FINALISTIC,
    targetDocumentStatus: documentStatus.AGUARDANDO_RESPOSTA_DE_REQUISITORIO_MINISTERIAL,
  },
  {
    code: '920021',
    name: 'Inst de IP (com prazo)',
    act: ACT_TYPES.FINALISTIC,
    targetDocumentStatus: documentStatus.AGUARDANDO_INQUERITO,
  },
  {
    code: '920197',
    name: 'Ciência de decisão',
    act: ACT_TYPES.FINALISTIC,
    targetDocumentStatus: null,
  },
  {
    code: '920155',
    name: 'Ciência de arquivamento',
    act: ACT_TYPES.FINALISTIC,
    targetDocumentStatus: documentStatus.ARQUIVADO,
  },
  {
    code: '920034',
    name: 'Aditamento de Denúncia',
    act: ACT_TYPES.FINALISTIC,
    targetDocumentStatus: null,
  },
  {
    code: '920200',
    name: 'Alegações Finais',
    act: ACT_TYPES.FINALISTIC,
    targetDocumentStatus: null,
  },
  {
    code: '920251',
    name: 'Conflito de Competência Negativo',
    act: ACT_TYPES.FINALISTIC,
    targetDocumentStatus: null,
  },
  {
    code: '920250',
    name: 'Conflito de Competência Positivo',
    act: ACT_TYPES.FINALISTIC,
    targetDocumentStatus: null,
  },
  {
    code: '920245',
    name: 'Impugnação aos Embargos',
    act: ACT_TYPES.FINALISTIC,
    targetDocumentStatus: null,
  },
  {
    code: '920124',
    name: 'Proposta de Transação Penal',
    act: ACT_TYPES.FINALISTIC,
    targetDocumentStatus: null,
  },
  {
    code: '920232',
    name: 'Contrarrazões/Contraminuta',
    act: ACT_TYPES.FINALISTIC,
    targetDocumentStatus: null,
  },
  {
    code: '920212',
    name: 'Interposição de Recurso',
    act: ACT_TYPES.FINALISTIC,
    targetDocumentStatus: null,
  },
  {
    code: '920009',
    name: 'Termo de Declaração',
    act: ACT_TYPES.FINALISTIC,
    targetDocumentStatus: null,
  },
  {
    code: '920253',
    name: 'Despacho - Separação Investigados (Outro Destino)',
    act: ACT_TYPES.FINALISTIC,
    targetDocumentStatus: null,
  },
  //{ code: '920253', name: 'Iniciar cumprimento acordo', targetDocumentStatus: null },
];

const listArquivar = [
  {
    code: '920113',
    name: 'Arquivamento com Remessa por Cumprimento de Acordo',
    act: ACT_TYPES.FINALISTIC,
    targetDocumentStatus: documentStatus.AGUARDANDO_RETORNO_DE_AUTOS,
  },
  {
    code: '920261',
    name: 'Arquivamento de Flagrante Aguardando IP',
    act: ACT_TYPES.COMMON,
    targetDocumentStatus: null,
  },
  {
    code: '920109',
    name: 'Arquivamento Interno para Infância e Juventude',
    act: ACT_TYPES.FINALISTIC,
    targetDocumentStatus: null,
  },
];

const listArquivarResolucaoCNMP = [
  {
    code: '920198',
    name: 'Manifestação ao Judiciário',
    act: ACT_TYPES.FINALISTIC,
    targetDocumentStatus: documentStatus.AGUARDANDO_RETORNO_DE_AUTOS,
  },
  {
    code: '920015',
    name: 'Inexistência de Crime',
    act: ACT_TYPES.FINALISTIC,
    targetDocumentStatus: documentStatus.AGUARDANDO_RETORNO_DE_AUTOS,
  },
  {
    code: '920103',
    name: 'Prescrição',
    act: ACT_TYPES.FINALISTIC,
    targetDocumentStatus: documentStatus.AGUARDANDO_RETORNO_DE_AUTOS,
  },
  {
    code: '920104',
    name: 'Decadência',
    act: ACT_TYPES.FINALISTIC,
    targetDocumentStatus: documentStatus.AGUARDANDO_RETORNO_DE_AUTOS,
  },
  {
    code: '920268',
    name: 'Ausência/insuf.Prova',
    act: ACT_TYPES.FINALISTIC,
    targetDocumentStatus: documentStatus.AGUARDANDO_RETORNO_DE_AUTOS,
  },
  {
    code: '920101',
    name: 'Desconhecimento do Autor',
    act: ACT_TYPES.FINALISTIC,
    targetDocumentStatus: documentStatus.AGUARDANDO_RETORNO_DE_AUTOS,
  },
  {
    code: '920483',
    name: 'Morte do agente',
    act: ACT_TYPES.FINALISTIC,
    targetDocumentStatus: documentStatus.AGUARDANDO_RETORNO_DE_AUTOS,
  },
  {
    code: '920109',
    name: 'Arq. Interno',
    act: ACT_TYPES.FINALISTIC,
    targetDocumentStatus: documentStatus.ARQUIVADO,
  },
  {
    code: '920155',
    name: 'Ciência de arquivamento',
    act: ACT_TYPES.FINALISTIC,
    targetDocumentStatus: documentStatus.ARQUIVADO,
  },
];

const listDeclinar = [
  {
    code: '920027',
    name: 'Mesmo ramo',
    act: ACT_TYPES.FINALISTIC,
    targetDocumentStatus: documentStatus.AGUARDANDO_DECISAO_JUDICIAL,
  },
  {
    code: '920028',
    name: 'Outro ramo',
    act: ACT_TYPES.FINALISTIC,
    targetDocumentStatus: documentStatus.AGUARDANDO_DECISAO_JUDICIAL,
  },
];

const listAudiencia = [
  {
    code: '920486',
    name: 'Audiência de Custódia',
    act: ACT_TYPES.FINALISTIC,
    targetDocumentStatus: null,
  },
  {
    code: '920062',
    name: 'Audiência Judicial',
    act: ACT_TYPES.FINALISTIC,
    targetDocumentStatus: null,
  },
  {
    code: '920203',
    name: 'Sessão do Tribunal do Juri',
    act: ACT_TYPES.FINALISTIC,
    targetDocumentStatus: null,
  },
  {
    code: '920197',
    name: 'Ciência de Audiência de Custódia',
    act: ACT_TYPES.FINALISTIC,
    targetDocumentStatus: null,
  },
  {
    code: '920198',
    name: 'Manifestação em Audiência de Custódia',
    act: ACT_TYPES.FINALISTIC,
    targetDocumentStatus: null,
  },
]; 


export {
  listSubtypeGeneric,
  listDespacho,
  listArquivar,
  listDeclinar,
  listInfanciaEJuventude,
  listArquivarResolucaoCNMP,
  listAudiencia,
  documentStatusList,
};
